<template>
  <ul class="ticketInfo">
    <li class="parkInfo">
      <span>{{ fullTicketInfo.title }}</span>
      <span>{{ selectDate.saleDate.slice(5) }}</span>
      <span>{{ selectDate.datePeriodInfo.periodName }}</span>
    </li>
    <li class="ticketNumber">
      <div class="ticket-list">
        <span v-for="item in controllerNumber" :key="item.metaTicketInfo.productId" v-if="item.count">{{ item.metaTicketInfo.englishName }}x{{ item.count }}</span>
      </div>
    </li>
  </ul>
</template>

<script>
export default {
  name: "ticketInfoEn",
  props: {
    controllerNumber: {
      type: Array,
      default:() =>[],
    },
    selectDate: {
      type: Object
    },
    fullTicketInfo: {
      type: Object
    },
  },
};
</script>

<style scoped lang='less'>
.ticketInfo{
  background: linear-gradient(135deg, #3B6D9C 0%, #588EC1 100%);
  color: #fff;
  padding: .266667rem;
  margin-bottom: .266667rem;
  .parkInfo{
    font-size: .48rem;
    font-weight: bold;
    line-height: .666667rem;
    span{
      &:first-child{
        padding-right: .333333rem;
        position: relative;
        &::before{
          content: '';
          position: absolute;
          width: 1px;
          height: .4rem;
          background: #fff;
          right: 0;
          top: 0;
          transform: translateY(25%);
        }
      };
      &:nth-child(2){
        margin: 0 .48rem;
      }
    }
  }
  .ticketNumber{
    font-size: .4rem;
    line-height: .56rem;
    margin-top: .266667rem;
    display: flex;
    .ticket-list{
      flex: 1;
      display: flex;
      flex-wrap: wrap;
      margin-left: -.4rem;
      span{
        margin-left: .4rem;
      }
    }
  }
}
</style>
